jQuery(document).ready(function($){
  var split_at = '.item-2';

  $(split_at).each(function() {
    $(this).add($(this).nextUntil(split_at)).wrapAll("<div class='grid'/>");
  });

  var show = 11;
  var total = $('.item').length;

  for ( let i = show; i <= total; i++ ){
    $('.item-' + i ).hide();
  };

  if (total < show){
    $('#load-more').hide();
  };

  $('#load-more').click( function(){
    for ( let i = show; i < total; i++ ){
      $('.item-' + i ).show();
    }
    $('#load-more').hide();
  });

  Fancybox.bind("[data-fancybox]", {});

	// Prevent scrolling when mobile menu is open
  $('.navbar-toggler').click( function () {
    $('body').toggleClass('prevent-scroll');
  })
  if ( $(window).width() <= 768 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
     $('.navbar-wrapper').toggleClass('active');
     $('.dropdown-menu').addClass('show');
   });

  	$('.nav-link').click(function(){
      $("#navbarNavDropdown").removeClass("show");
      $("button.navbar-toggler").addClass("collapsed");
      $("button.navbar-toggler").attr("aria-expanded","false");
    });

  } else {

  	//open menu on hover for desktop
    $('#menuToggle, #navbarNavDropdown').hover(function(){
     $('.navbar-wrapper').addClass('active');
   }, function(){
     $('.navbar-wrapper').removeClass('active');
   });

		//add dropdown menu toggle functionality to down arrow
    $('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');

    $('.dropdown-toggle.nav-link a').click(function(e){
      $( this ).toggleClass('active');
      $( this ).parent().siblings('.dropdown-menu').toggleClass('show');
    })
  }
  document.addEventListener("DOMContentLoaded", function () {
   const mybutton = document.getElementById("btt");

   if (mybutton) {
	    // Show/hide on scroll
     window.addEventListener("scroll", function () {
       if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
         mybutton.style.display = "block";
       } else {
         mybutton.style.display = "none";
       }
     });

	    // Scroll to top on click
     mybutton.addEventListener("click", function () {
	      document.body.scrollTop = 0; // For Safari
	      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	    });
   }
 });
});